import client from '@services/TokenInterceptorServices';

export const getPlYearlyMetrics = async (YEAR, EMAIL, DATE) => {
  const URL = '/pl/dashboard/yearlymetrics';
  const PAYLOAD = { year: YEAR, email: EMAIL, date: DATE };
  const RESPONSE = await client.post(URL, PAYLOAD);
  return RESPONSE.data[0];
};

export const getOpportunitiesDetails = async (EMAIL, TODAYS_DATE) => {
  const URL = '/pl/forecast/opportunities';
  const LOCAL_DATE = new Date(TODAYS_DATE);
  const PAYLOAD = {
    email: EMAIL,
    date: TODAYS_DATE,
    offset: LOCAL_DATE.getTimezoneOffset(),
  };
  const RESPONSE = await client.post(URL, PAYLOAD);
  return RESPONSE.data;
};

export const getQuaterlyDetails = async (EMAIL, START_DATE, END_DATE) => {
  const URL = '/pl/forecast/quaterly/opportunities';
  let PAYLOAD = {};
  if (START_DATE !== '' && END_DATE !== '') {
    PAYLOAD = { email: EMAIL, start_date: START_DATE, end_date: END_DATE };
  }
  const RESPONSE = await client.post(URL, PAYLOAD);
  return RESPONSE.data;
};

export const getMyDashboardData = async (YEAR, EMAIL, DATE) => {
  const URL = '/pl/dashboard/currentmetrics';
  const PAYLOAD = { year: YEAR, email: EMAIL, date: DATE };
  const RESPONSE = await client.post(URL, PAYLOAD);
  return RESPONSE.data;
};

export const subHeaderPLPastQtrDetails = async (QUARTER, YEAR, EMAIL) => {
  // Email Required *
  const URL = '/user/quarter';
  const PAYLOAD = { quarter: QUARTER, year: YEAR, email: EMAIL };
  const RESPONSE = await client.post(URL, PAYLOAD);
  return RESPONSE.data;
};

export const subHeaderPLPastMonthDetails = async (QUARTER, MONTH, YEAR, EMAIL) => {
  // Email Required *
  const URL = '/user/quarter';
  const PAYLOAD = { quarter: QUARTER, year: YEAR, month: MONTH, email: EMAIL };
  const RESPONSE = await client.post(URL, PAYLOAD);
  return RESPONSE.data;
};

export const pastMonthlyopportunitiesPL = async (EMAIL, YEAR, QUARTER, MONTH) => {
  const URL = '/pl/past/opportunities';
  const PAYLOAD = { quarter: QUARTER, year: YEAR, month: MONTH, email: EMAIL };
  const RESPONSE = await client.post(URL, PAYLOAD);
  return RESPONSE.data;
};

export const pastQuaterlyopportunitiesPL = async (EMAIL, YEAR, QUARTER) => {
  const URL = '/pl/past/opportunities';
  const PAYLOAD = { quarter: QUARTER, year: YEAR, email: EMAIL, month: 'null' };
  const RESPONSE = await client.post(URL, PAYLOAD);
  return RESPONSE.data;
};

export const submitPlOpportunity = async REQ_BODY => {
  try {
    const URL = 'pl/submit/forecast';
    const response = await client.post(URL, REQ_BODY);
    if (response.status === 200) {
      const URL = '/pl/submit/updatecrm';
      const result = await client.post(URL, {
        crm_update: REQ_BODY.crm_update,
        email: REQ_BODY.email,
      });
      if (result.status === 200) {
        return true;
      } else {
        return false;
      }
    } else {
      return false;
    }
  } catch (error) {
    return false;
  }
};

export const getNowNextBeyondSidebarData = async (DATA_TITLE, EMAIL, DATE, YEAR, QUARTER) => {
  let URL;
  let PAYLOAD = {};
  if (DATA_TITLE === 'beyond') {
    URL = `/pl/forecast/sidebar/${DATA_TITLE}`;
    PAYLOAD = {
      email: EMAIL,
      date: DATE,
      year: YEAR,
      quarter: QUARTER,
    };
  } else {
    URL = `/pl/forecast/sidebar/${DATA_TITLE}`;
    PAYLOAD = {
      email: EMAIL,
      date: DATE,
      year: YEAR,
    };
  }
  const RESPONSE = await client.post(URL, PAYLOAD);
  return RESPONSE.data;
};

export const pastSidebarPL = async (EMAIL, YEAR, QUARTER, DATE) => {
  const URL = '/pl/dashboard/quaterlymetrics';
  const PAYLOAD = { quarter: QUARTER, year: YEAR, date: DATE, email: EMAIL };
  const RESPONSE = await client.post(URL, PAYLOAD);
  return RESPONSE.data;
};
